import { NumberFormatStyle } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConstant } from 'src/app/app.constant';

@Injectable({
  providedIn: 'root'
})
export class AgentService  {
  apiUrl: string;
  kendoDataUrl: string;

  constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl()
  }
  manageAgent(agent) {
    return this.httpClient.post(`${this.apiUrl}/manageAgent`, agent).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAgentById(agentId) {
    return this.httpClient.get(`${this.apiUrl}/getAgentById/` + agentId).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  bulkDeleteAgent(agentData) {
    let params = {
      DataToDelete: agentData
    }
    return this.httpClient.post(`${this.apiUrl}/bulkDeleteAgent`, params).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  deleteAgent(id: number, userId: number) {
    return this.httpClient.delete(`${this.apiUrl}/deleteAgent/` + id + '/app/' + userId).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  deleteAgentType(agentTypes) {
    return this.httpClient.post(`${this.apiUrl}/deleteAgentCategories`, agentTypes).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllAgents() {
    return new Promise((resolve, reject) => {
      this.httpClient.get(`${this.apiUrl}/getAllAgent/`).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  getAgentCategotries() {
    return this.httpClient.get(`${this.apiUrl}/getAllAgentCategory/`).pipe(
      map((response: any) => {
        let data = response.data
        return {
          data: data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  getAgentCategoryById(catId) {
    return this.httpClient.get(`${this.apiUrl}/getAgentCategoryById/` + catId).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  manageAgentCategory(cat) {
    return this.httpClient.post(`${this.apiUrl}/manageAgentCategory`, cat).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  public getAllAgentKendo(IsActive = true): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllAgent?IsActive=${IsActive}`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult;
      })
    ) as any as Observable<GridDataResult>;
  }
}
